import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=3665d4be&scoped=true&"
import script from "./EditProduct.vue?vue&type=script&lang=js&"
export * from "./EditProduct.vue?vue&type=script&lang=js&"
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=3665d4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665d4be",
  null
  
)

export default component.exports